import React from 'react';
import { Input, Button } from 'semantic-ui-react';
import AGTable from 'src/components/table/aggrid';
import { objectToString, profileImage, scrollUp } from 'src/components/helpers';
import EventHeading from 'src/containers/events/EventHeading';
import moment from 'src/services/moment_instance';
import { agGridDateCreatedAtFieldComparator } from 'src/components/table/helpers';
import {
  AdminTableNetworkSection,
  AdminTableContent,
} from 'src/assets/styles/components/AdminTable';

const columnDefs = ({ history }) => [
  {
    headerName: 'Foto',
    field: 'photo',
    sortable: false,
    filter: false,
    minWidth: 120,
    maxWidth: 140,
    cellRenderer: (params) => (
      <img
        src={profileImage(params.data?.GeneracionesGuest)}
        alt="Invitado"
        style={{ width: 50, height: 50, borderRadius: '50%', objectFit: 'cover' }}
      />
    ),
  },
  {
    headerName: 'Nombre',
    field: 'name',
    valueGetter: (params) =>
      `${params.data?.GeneracionesGuest?.name || ''} ${
        params.data?.GeneracionesGuest?.lastName || ''
      }`.trim(),
    minWidth: 200,
    flex: 1.5,
  },
  {
    headerName: 'Edad',
    field: 'age',
    valueGetter: (params) => moment().diff(params.data?.GeneracionesGuest?.birthdate, 'years'),
    minWidth: 100,
  },
  {
    headerName: 'Acudiente',
    field: 'parent',
    valueGetter: (params) =>
      `${params.data?.GeneracionesGuest?.parent?.name || ''} ${
        params.data?.GeneracionesGuest?.parent?.lastName || ''
      }`.trim(),
    minWidth: 200,
    flex: 1.5,
  },
  {
    headerName: 'Teléfono',
    field: 'phone',
    valueGetter: (params) => params.data?.GeneracionesGuest?.parent?.phone || 'N/A',
    minWidth: 140,
  },
  {
    headerName: 'Ingresó',
    field: 'entryConfirmed',
    valueGetter: (params) => (params.data?.entryConfirmed ? 'Sí' : 'No'),
    minWidth: 120,
  },
  {
    headerName: 'Primera inscripción',
    field: 'createdAt',
    valueGetter: (params) =>
      params.data?.GeneracionesGuest?.createdAt
        ? moment(params.data?.GeneracionesGuest?.createdAt).format('DD/MM/YYYY hh:mm a')
        : 'N/A',
    comparator: agGridDateCreatedAtFieldComparator,
    minWidth: 200,
  },
  {
    headerName: 'Info Extra',
    field: 'aditionalinformation',
    valueGetter: (params) =>
      Object.keys(params.data?.GeneracionesGuest?.aditionalinformation || {}).length ? 'Sí' : 'No',
    cellRenderer: (params) =>
      Object.keys(params.data?.GeneracionesGuest?.aditionalinformation || {}).length ? (
        <div
          dangerouslySetInnerHTML={{
            __html: objectToString(params.data?.GeneracionesGuest?.aditionalinformation),
          }}
        />
      ) : (
        'No'
      ),
    minWidth: 180,
    flex: 1.5,
  },
  {
    headerName: 'Ver más',
    field: 'actions',
    sortable: false,
    filter: false,
    minWidth: 140,
    cellRenderer: (params) => (
      <Button
        onClick={() =>
          history?.push(
            `/servicio/generaciones?identification=${params.data?.GeneracionesGuest?.parent?.identification}`
          )
        }
      >
        Ver
      </Button>
    ),
  },
];

const GeneracionesChurchServiceGuests = (props) => {
  const [inputs, setInputs] = React.useState({});
  const [inScreen, set_inScreen] = React.useState(0);

  React.useEffect(() => {
    scrollUp();
  }, []);

  const handleInputs = (event) => {
    let value = event.target.value;
    let name = event.target.name;
    setInputs({ ...inputs, [name]: value });
  };

  const filterUsers = (word) => {
    let serviceFiltered = props.serviceAttendance;
    if (word)
      serviceFiltered = serviceFiltered.filter(
        (att) =>
          att.GeneracionesGuest.name.toLowerCase().includes(word.toLowerCase()) ||
          att.GeneracionesGuest.lastName.toLowerCase().includes(word.toLowerCase()) ||
          att.GeneracionesGuest?.parent?.name?.toLowerCase()?.includes(word.toLowerCase())
      );

    if (serviceFiltered.length !== inScreen) set_inScreen(serviceFiltered.length);
    return serviceFiltered;
  };

  return (
    <AdminTableNetworkSection>
      <AdminTableContent>
        <Button onClick={() => props.set_serviceAttendance([])}>Atrás</Button>
        <h2>Niños en el servicio</h2>
        <EventHeading name={props.generacionesCategory} date={props.clickedEvent?.date} />
        <p style={{ padding: '20px 0 0 0', margin: 0 }}>
          <strong>Total usuarios:</strong> {props.serviceAttendance.length}
        </p>
        <p style={{ padding: '0 0 0 0', margin: 0 }}>
          <strong>Total usuarios en pantalla:</strong> {inScreen}
        </p>
        <div className="options" style={{ padding: '20px 0 0 0', margin: 0 }}>
          <div className="search-query">
            <p style={{ padding: '0 0 0 0' }}>Buscar</p>
            <Input
              name={'keyword'}
              onChange={handleInputs}
              value={inputs.keyword}
              placeholder="Buscar"
            />
          </div>
        </div>
      </AdminTableContent>

      <div style={{ height: '70vh', width: '100%', margin: '20px 0' }}>
        <AGTable
          columnDefs={columnDefs({ history: props.history })}
          rowData={filterUsers(inputs.keyword)}
          rowHeight={70}
          defaultCol={{ autoHeight: true }}
          pagination
        />
      </div>
    </AdminTableNetworkSection>
  );
};

export default GeneracionesChurchServiceGuests;
